import { Injectable, signal } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { environment } from '../../../environments/environment';
import { ReleasePublishedNotification } from '../../shared/models/release.model';

@Injectable({ providedIn: 'root' })
export class ReleasesSignalrService {
  readonly latestPublishedRelease = signal<ReleasePublishedNotification | null>(null);
  private hubConnection?: signalR.HubConnection;

  startConnection(): void {
    if (this.hubConnection) {
      return;
    }

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.hubBaseUrl}/hubs/releases`)
      .withAutomaticReconnect()
      .build();

    this.hubConnection.on('ReleasePublished', (data: ReleasePublishedNotification) => {
      this.latestPublishedRelease.set(data);
    });

    this.hubConnection.start().catch((err) => {
      this.hubConnection = undefined;
      console.warn('SignalR connection failed:', err);
    });
  }
}
